export const generateDelayPayload = (delay) => {
  if (!delay?.value) return undefined;
  return `${delay?.value}#${delay?.delayUnit ?? 'minutes'}`;
};
